import { graphql, DataValue } from '@apollo/client/react/hoc';
import * as React from 'react';
import memoize from 'memoizee';

import SEARCH_FOR_FAMILY_QUERY from './SEARCH_FOR_FAMILY_MEMBERS_QUERY.gql';

import type {
  SearchForFamilyMembers,
  SearchForFamilyMembers_potentialFamily,
} from './__generated__/SearchForFamilyMembers';

const DATA_RELOAD_TIMEOUT_MS = 5 * 60 * 1000; // 5 minutes, for memoize

type Props = {
  children: (props: {
    loading: boolean;
    familyMembers: ReadonlyArray<SearchForFamilyMembers_potentialFamily>;
  }) => React.ReactNode;
  query: string;
  relation: 'parent' | 'child';
  data?: DataValue<SearchForFamilyMembers>;
  isMinQueryLength: boolean;
};

class FamilyTypeaheadContainer extends React.Component<Props, {}> {
  componentDidUpdate(prevProps: Props) {
    if (prevProps.query !== this.props.query && this.props.isMinQueryLength) {
      this.loadQuery(this.props.query);
    }
  }

  loadQuery = memoize(
    (query: string) => {
      this.props.data?.refetch({ query });
    },
    { maxAge: DATA_RELOAD_TIMEOUT_MS }
  );

  isLoading = (props: Props): boolean => {
    return props.data?.loading || (props.data?.networkStatus ?? 7) < 7;
  };

  getFamilyMembers = (props: Props) => {
    return props.data?.potentialFamily || [];
  };

  render() {
    return this.props.children({
      loading: this.isLoading(this.props),
      familyMembers: this.getFamilyMembers(this.props),
    });
  }
}

const withFamilyResults = graphql<Props>(SEARCH_FOR_FAMILY_QUERY, {
  options: ({ relation, query }) => ({
    variables: {
      relation,
      query,
    },
  }),
  skip: ({ isMinQueryLength }) => !isMinQueryLength,
});

export { FamilyTypeaheadContainer };

// @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'typeof FamilyTypeaheadContainer'... Remove this comment to see the full error message
export default withFamilyResults(FamilyTypeaheadContainer);
